import isArray from "../../common-utils/array/isArray.util.js";
export const mergeSxPropUtil = (...sxProps) => sxProps.reduce((sx, sxProp) => {
    if (!sxProp)
        return sx;
    if (isArray(sxProp))
        return [...sx, ...sxProp];
    return [...sx, sxProp];
}, []);
export default mergeSxPropUtil;
